<template>
  <div class="table myTask">
    <div class="container ">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryForm" :label-position="labelPosition" label-width="100px" class="searchForm">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item :label="$t('taskList.taskFlow')" prop="taskTypes">
                <ic-select multiple style="width:100%" :clearable="true" v-model="queryCondition.taskTypes" :options="{
                SENSORY_REPORT:'Sensory报告模板审批',
								LINE_SOURCING:'按线路报价价格确认流程',
								QUOTATION:'供应商报价',
								PRODUCT_SOURCING:'按产品报价价格确认流程',
								STORE_FEEDBACK:'质量反馈',
								PROBLEM_REPORT_HANDLE:'问题报告处理',
								MSV:'MSV审核',
                SUPPLIER_REG:'潜在供应商',
                SUPPLIER_REG_MDM:'潜在供应商MDM',
								SUPPLIER_UPDATE:'供应商资源管理',
								FPA_PERMANENT:'FPA_PERMANENT',
								FPA_LTO_CAMPAIGN:'FPA_LTO_CAMPAIGN',
								FPA_LTO:'FPA_LTO',
                BC:'BC',
								GRI:'GRI',
                CAPACITY:'产能调查',
								UNIT_OF_ACCOUNT:'结算单位',
								LAW_FILE:'法务文件',
                MATERIAL:'物料审核',
								DC:'DC审核',
								}"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('taskList.bizNo')" prop="bizNo">
                <el-input class="handle-input" v-model.trim="queryCondition['bizNo']" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期(从)" prop="dateFrom">
                <el-date-picker style="width: 100%" v-model="queryCondition.dateFrom" type="date" :picker-options="pickerOptionsStart" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期(至)" prop="dateTo">
                <el-date-picker style="width: 100%" value-format="yyyy-MM-dd" v-model="queryCondition.dateTo" :picker-options="pickerOptionsEnd" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row justify="center" type="flex">
            <el-button class="btn" size="mini" type="primary" @click="queryData(1)">{{$t("common.search")}}</el-button>
            <el-button class="btn" size="mini" type="primary" @click="resetForm()">{{$t("common.reset")}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" border max-height='550' highlight-current-row>
        <el-table-column sortable align="center" prop="taskTypeName" :label="$t('taskList.taskFlow')"></el-table-column>
        <el-table-column sortable align="center" prop="taskName" :label="$t('apply.applyType')"></el-table-column>
        <el-table-column sortable align="center" prop="bizNo" :label="$t('taskList.bizNo')" min-width="140"></el-table-column>
        <el-table-column sortable align="center" prop="createDate" :label="$t('common.TaskCreationTime')"><template slot-scope="scope">{{scope.row.createDate|dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}</template></el-table-column>
        <el-table-column sortable align="center" :label="$t('common.operation')">
          <template slot-scope="scope">
            <el-button size="mini" @click="audit(scope.row.taskType,scope.row.bizId,scope.row)" type="primary">{{$t("taskList.audit")}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination :page-sizes="[10,15,50,100]" @size-change="pageSizeChange" :page-size="queryCondition.pageSize" :current-page="queryCondition.pageNum" @current-change="pageNumberChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <!-- <el-dialog title="审核" :visible="auditDialog" @close="closeAuditDialog" width="1200px" class="dialog">
      <router-view></router-view>
    </el-dialog> -->
    <!-- <el-dialog title="审核" :visible="proAuditDialog" @close="closeProAuditDialog" width="1200px" class="dialog">
      <router-view></router-view>
    </el-dialog> -->
  </div>
</template>
<script>
import taskApi from "../../../api/myTask";
import { Message } from "element-ui";
import dataTableUtils from '../../../utils/dataTableUtils';
import IcSelect from "@/components/common/icSelect";
import pickupUser from "@/components/common/pickupUser";
import DateRanger from "@/components/common/dateRanger";
import commonFun from "@/utils/commonFun";
export default {
  name: 'user-manage',
  components: {
    DateRanger,
    IcSelect,
  },
  data() {
    return {
      tableData: [],
      total: 0,
      labelPosition: 'right',
      queryCondition: {
        taskName: '',
        taskTypeName: '',
        eightBitCodeName: '',
        pageNum: 1,
        pageSize: 15,
        createDateArr: '',
        dateFrom: '',
        dateTo: '',
        taskTypes: [],
        bizNo: ''
      },
      // auditDialog: false,
      // proAuditDialog:false,
      userForm: {
        id: '',
        name: '',
        login: '',
        routeNodes: [],
        authorities: []
      },
      routeNodes: [],
      userRouteNodes: [],
      authorities: [],
      userAuthorities: [],
      authSearch: '',
      routeObj: {
        key: 'routeNodeId',
        label: 'routeNodeName'
      },
      src: '',
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.dateTo;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.dateFrom;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    }
  },
  created() {
    this.queryData(1);
  },
  mounted() {
    // if (this.$route.meta.auditDialog) {
    //   this.auditDialog = true;
    // } else {
    //   this.auditDialog = false;
    // }
    // if (this.$route.meta.proAuditDialog) {
    //   this.proAuditDialog = true;
    // } else {
    //   this.proAuditDialog = false;
    // }
  },
  extends: dataTableUtils,
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      taskApi.myTasklist(this.queryCondition).then((res) => {
        this.tableData = res.data.records;
        this.tableData.forEach(row => {
          if (row.taskType == "PROBLEM_REPORT_HANDLE" || row.taskType == "STORE_FEEDBACK") {
            let bizInfo = row.bizNo.split(";");
            row.bizNo = bizInfo[0];
          }
        })
        this.total = res.data.total;
      });
    },
    changeImg(piId) {
      taskApi.getImg(piId)
        .then(response => {
          return new Buffer(response, 'binary').toString('base64');
        })
        .then(data => {
          this.src = "data:image/png;base64," + data;
          this.imgDialog = true;
        });
    },
    /**
     * 多选
     * @param val
     */
    authChange(val) {
      this.userForm.authorities = val;
    },
    resetForm() {
      this.$refs['queryForm'].resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryCondition.dateFrom = ''
      this.queryCondition.dateTo = ''
      this.queryData(1)
    },
    audit(taskType, bizId, row) {
      console.log('taskType', taskType);
      var that = this;
      let taskName = row.taskName;
      if (commonFun.isNotEmpty(row.auditPath)) {
        this.$router.push({ path: row.auditPath, query: { id: bizId } });
      }
      switch (taskType) {
        //供应商报价
        case "QUOTATION":
          if (row.bizNo.startsWith('PX')) {
            that.$router.push({ path: `/inquiry-quotation-product-sp-detail`, query: { roundId: bizId } });
          } else {
            that.$router.push({ path: `/quotation-sp-detail/${bizId}` });
          }
          break;
        //MSV审核
        case "MSV":
          if (taskName == "审核中") {
            that.$router.push({ path: `/visitReportAudit`, query: { ttMsvReportId: bizId } });
          } else {
            that.$router.push({ path: `/visitReport-add`, query: { ttMsvReportId: bizId } });
          }
          break;
        //Sensory报告模板审批
        case "SENSORY_REPORT":
          this.$router.push({
            path: `/sensoryTemplate-add`,
            query: { ttSensoryTemplateId: bizId, taskApproval: true },
          });
          break;
        //按线路报价价格确认流程
        case "LINE_SOURCING":
          this.$router.push({ name: "auditSourcing", query: { sourcingId: bizId } });
          // that.auditDialog = true;
          break;
        //按产品报价价格确认流程:/auditLineSourcing
        case "PRODUCT_SOURCING":
          this.$router.push({ name: "auditProSourcing", query: { sourcingId: bizId } });
          // that.proAuditDialog = true;
          break;
        //问题报告处理
        case "PROBLEM_REPORT_HANDLE":
          switch (taskName) {
            case '调查报告待提交':
              that.$router.push({ name: `feedbackReportView`, query: { feedbackReportId: bizId } });
              break;
            case '问题报告驳回':
              that.$router.push({ name: "feedbackReportView", query: { action: 'audit', feedbackReportId: bizId } });
              break;
            case 'MCD处理':
              that.$router.push({ path: `/feedbackReport/approve`, query: { feedbackReportId: bizId } });
              break;
            case '质量反馈中心处理':
              that.$router.push({ path: `/feedbackReport/approve`, query: { feedbackReportId: bizId } });
              break;
            case '质量反馈中心处理疑问反馈':
              that.$router.push({ path: `/feedbackReportQuestion-detail`, query: { feedbackReportId: bizId } });
              break;
            default:
              that.$router.push({ name: "feedbackReportView", query: { action: 'audit', feedbackReportId: bizId } });
          }
          break;
        //质量反馈
        case "STORE_FEEDBACK":
          this.$router.push({
            path: `/storeFeedback-detail`,
            query: {
              feedbackId: bizId
            }
          });
          break;
        //产能调查
        case "CAPACITY":
          this.$router.push({
            path: `/capacityDetail`,
            query: { ttCapacityId: bizId },
          });
          break;
        //FPA_PERMANENT
        case "FPA_PERMANENT":
          this.$router.push({
            name: 'fpaPermanentDetail',
            params: { ttFpaId: bizId, isCopy: 'N' }
          });
          break;
        //FPA_LTO_CAMPAIGN
        case "FPA_LTO_CAMPAIGN":
          this.$router.push({
            name: 'fpaLtoCampaignDetail',
            params: { ttFpaLtoCampaignId: bizId }
          });
          break;
        //FPA_LTO
        case "FPA_LTO":
          this.$router.push({
            name: 'fpaLtoDetail',
            params: { ttFpaLtoId: bizId }
          });
          break;
      }
    },
    closeAuditDialog() {
      this.auditDialog = false;
      this.queryData()
      this.$router.go(-1);
    },
    closeProAuditDialog() {
      this.proAuditDialog = false;
      this.queryData()
      this.$router.go(-1);
    },
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}
.dialog-input {
  width: 85%;
}
.dialog >>> .el-dialog__body {
  max-height: 450px;
  overflow: auto;
}
.el-select {
  width: 100%;
}
</style>
<style scoped>
/* .myTask .el-date-editor--daterange.el-input__inner {
  width: auto;
} */
</style>

